<template>
    <CompassTableRow class="reports-listing-table-row" @click="handleClickRow($event)">
        <template v-for="column in columns">
            <CompassTableBodyCell
                v-if="column.code === 'favorite'"
                :key="column.code"
                :maxWidth="column.maxWidth"
                :minWidth="column.minWidth"
            >
                <CompassTooltip :content="contentTooltipFavorite" :arrow="false">
                    <CompassIconButton
                        :icon="isFavorite ? 'star-fill' : 'star'"
                        :class="classesFavIcon"
                        :disabled="loadingBtnFavorite"
                        @click.stop="toggleFavorite"
                    />
                </CompassTooltip>
            </CompassTableBodyCell>
            <CompassTableBodyCell
                v-if="column.code === 'name'"
                :key="column.code"
                :maxWidth="column.maxWidth"
            >
                <div class="reports-listing-table-row__cell--name">
                    <span class="typographies-paragraph-medium-bold">
                        {{ report.name }}
                    </span>
                    <CompassFlag
                        v-if="report.new"
                        :label="$t.__('common.labels.new')"
                        size="small"
                    />
                </div>
            </CompassTableBodyCell>
            <CompassTableBodyCell
                v-if="column.code === 'category'"
                :key="column.code"
                :maxWidth="column.maxWidth"
                :minWidth="column.minWidth"
            >
                <CompassTag v-if="showCategory" :color="getColorTag">
                    {{ getLabelCategory }}
                </CompassTag>
            </CompassTableBodyCell>
        </template>
    </CompassTableRow>
</template>

<script>
import { goToUrl } from 'vueDir/helpers.js';
import reportsMixins from 'mixins/reports/reportsMixins.js';

import { createNamespacedHelpers } from 'vuex';
const { mapState: corpMapState } = createNamespacedHelpers('corp');

export default {
    mixins: [reportsMixins],
    props: {
        columns: {
            type: Array,
            required: true,
        },
        report: {
            type: Object,
            required: true,
        },
        cumulioAuth: {
            // This prop is used for redirecting to reports dashboard
            type: Object,
            required: true,
        },
    },
    computed: {
        ...corpMapState(['timeformat', 'hourformat']),
        classesFavIcon() {
            return {
                'reports-listing-table-row__favorite-icon': true,
                'reports-listing-table-row__favorite-icon--active':
                    this.isFavorite && !this.loadingBtnFavorite,
                'reports-listing-table-row__favorite-icon--loading': this.loadingBtnFavorite,
            };
        },
    },
    methods: {
        handleClickRow(event) {
            const isCtrlClick = event.ctrlKey || event.metaKey;

            if (this.report.type === 'legacy') {
                if (isCtrlClick) {
                    window.open(this.report.path, '_blank');
                } else {
                    return goToUrl(this.report.path);
                }
                return;
            }
            const routeData = this.$router.resolve({
                name: 'reports.dashboard',
                params: {
                    id: this.report.id,
                },
            });
            if (isCtrlClick) {
                window.open(routeData.href, '_blank');
            } else {
                this.$router.push({
                    name: 'reports.dashboard',
                    params: {
                        id: this.report.id,
                    },
                });
            }
        },
        // Toggle favorite state (used on mixin)
        // eslint-disable-next-line vue/no-unused-properties
        onFavoriteToggleSuccess(newFavoriteState) {
            this.$emit('update-favorite', {
                reportId: this.report.id,
                isFavorite: newFavoriteState,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.reports-listing-table-row {
    cursor: pointer;

    &__cell--name {
        display: flex;
        align-items: center;
        gap: var(--spacing-0);
        user-select: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    &__favorite-icon {
        color: var(--colors-common-icon-fav-default);

        &--active {
            color: var(--colors-common-icon-fav-active);
        }
        &--loading {
            color: var(--colors-common-icon-fav-default);
        }
    }
}
</style>

<style lang="scss">
.compass-tooltip__content--name {
    max-width: 424px;
}
</style>
